import { useMemo } from 'react';

function toArray(val) {
  // eslint-disable-next-line no-nested-ternary
  return val ? Array.isArray(val) ? val : [val] : [];
}

function useAction(action, showAction, hideAction) {
  return useMemo(function () {
    var showActions = toArray(showAction !== null && showAction !== void 0 ? showAction : action);
    var hideActions = toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
    return [Array.from(new Set(showActions)), Array.from(new Set(hideActions))];
  }, [action, showAction, hideAction]);
}

export default useAction;